import { render, staticRenderFns } from "./YKHistoryCase.vue?vue&type=template&id=5d8f1634&scoped=true&"
import script from "./YKHistoryCase.vue?vue&type=script&lang=js&"
export * from "./YKHistoryCase.vue?vue&type=script&lang=js&"
import style0 from "./YKHistoryCase.vue?vue&type=style&index=0&id=5d8f1634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f1634",
  null
  
)

export default component.exports